import { createTheme } from "@mui/material/styles";

const createAdminTheme = (defaultTheme) => createTheme({
  palette: {
    primary: {
      main: "#14447b",
    },
    secondary: {
      main: "rgb(26,107,173)",
    },
  },
  typography: {
    fontFamily: "Inter",
    fontWeightRegular: 500,
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 600,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          lineHeight: 1.2,
          fontSize: "12px",
          minHeight: "30px",
          paddingTop: "5px",
          paddingBottom: "5px",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          "&$disabled": {
            "color": "rgba(0, 0, 0, 0.60)",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "14px",
        },
      },
    },
    MuiFormGroup: {
      styleOverrides: {
        root: {
          marginTop: "2px",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: "14px",
          "&$disabled": {
            "color": "rgba(0, 0, 0, 0.60)",
          },
          "&$disabled$filled": {
            "color": "rgba(0, 0, 0, 0.87)",
          },
          "&$filled": {
            "color": "rgba(0, 0, 0, 0.87)",
            "&$focused": {
              "color": "#335074",
            },
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          "&$colorSecondary": {
            "&$disabled": {
              "color": "rgba(0, 0, 0, 0.40)",
            },
          },
          padding: "6px 6px 6px 9px",
        },
      },
      defaultProps: {
        size: "small",
      },
    },
    MuiTypography: {
      styleOverrides: {
        subtitle1: {
          fontWeight: 600,
          "&:not(:first-child)": {
            marginTop: 12,
          },
        },
        h6: {
          fontWeight: 700,
        },
        h5: {
          fontWeight: 700,
        },
        body2: {
          fontSize: 14,
          "&:not(:first-child)": {
            marginTop: 7,
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        input: {
          padding: "5px 0 !important",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        label: {
          "& svg": {
            margin: "0 6px -3px -2px",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          marginBottom: 2,
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          paddingBottom: "10px"
        }
      }
    }
  },
});

export { createAdminTheme };
